<div class="experience-toggle-wrapper">
    <span
        (click)="switchUserExperience(null, null)"
        [ngClass]="!userService.hasStudentExperience() ? 'active' : ''"
        class="teacher gtm-teacher-experience-toggle"
        >Teacher view</span
    >
    <span
        (click)="switchUserExperience(true, null)"
        [disableTooltip]="canSwitchToStudentExperience"
        [ngClass]="{
            active: userService.hasStudentExperience(),
            'disabled-with-tooltip': !canSwitchToStudentExperience,
        }"
        [ngbTooltip]="tooltip"
        [placement]="innerWidth < 576 ? 'top-right' : 'top'"
        class="student gtm-student-experience-toggle"
        tooltipClass="experience-toggle-tooltip"
    >
        Student view
    </span>
    <ng-template #tooltip>
        This resource has no student view due to content or audience restrictions.
        <app-link
            [href]="'https://www.pbslearningmedia.org/help/content-types/'"
            [target]="'_blank'"
            >More Info</app-link
        >
    </ng-template>
</div>
